import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { resetFilter } from 'redux/actions/newFilter';
import { getListOrder, getAllListOrder } from '../../redux/actions/delivery';

import OrderList from './OrderList.page';

const mapStateToProps = state => ({
  loading: state.delivery.loading,
  loadingCSV: state.delivery.loadingCSV,
  listOrder: state.delivery.listOrder,
  orderListFilter: state.delivery.orderListFilter,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
  deliveryCSV: state.delivery.dataCSV,
});

const mapDispatchToProps = {
  getListOrder,
  getAllListOrder,
  resetFilter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(OrderList));
